import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.tooltip-container {
    border: 1px solid black;
    background-color: #ffffff;
    max-width: 250px;
    line-height: 1em;
}
@media (max-width: 720px) {
    .tooltip-container {
        max-width: 125px;
    }
}
.title {
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    background-color: #4c5a69;
    color: #ffffff;
    padding: 10px;
    font-size: 14px;
}
.data-container {
    padding: 5px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
}
.data-label {
    padding: 5px 0;
}
.data-value {
    padding: 5px 0;
}
.data-label {
    font-size: 12px;
}
.data-value {
    font-size: 16px;
}
.data-container .data-value.blue {
    color: #054c70;
}
.wrap-name {
    white-space: pre-wrap; /* css-3 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
}
.wrap-title {
    white-space: normal;
    line-height: 1.4em;
    word-wrap: break-word; /* Internet Explorer 5.5+ */
}
`;

export default styles;